export const ContactNameRegex = /^[a-zA-Z'’][a-zA-Z'’\s]*$/;
export const EmailRegex =
  /^(?=.{1,129}$)(?=[^@]+@.{1,63}$)(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_{|}~`-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~`-]+)*@[a-zA-Z0-9ß-]+(\.[a-zA-Z0-9ß-]+)*\.[a-zA-Zß]+$/;

export const ADDRESS_REGEX = /^[\w/.~=[\]*$&",';: #’\\-]+[\w/.~=[\]*$&",';: #’\\-]$/;
export const ZIP_REGEX = /^\d{5}$/;
export const CITY_REGEX = /^[A-Za-z -]+$/;

export const vinRegex = /^[A-HJ-NPR-Z0-9]+$/;
export const vinNotAllowedRegex = /[^A-Z0-9]/;
export const vinNotAllowedAlphabetRegex = /[IOQ]/;
export const NewVehicleRegex = /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/;
